import { create } from 'zustand';
import { EDIT_RESOURCE_FORM } from '@shared/constants/editResourceFormKey';

export const useIsSubmitDisabledStore = create((set, get) => ({
  isFormSubmitDisabledStates: {
    [EDIT_RESOURCE_FORM]: true
  },
  isSubmitDisabled: formId => get().isFormSubmitDisabledStates[formId] ?? false,
  setIsSubmitDisabled: (formId, isDisabled) =>
    set(state => ({
      isFormSubmitDisabledStates: { ...state.isFormSubmitDisabledStates, [formId]: isDisabled }
    }))
}));
